import { takeEvery, put, call } from "redux-saga/effects";
import endpoints, { endpointTypes } from "../../service";
import { fetchAPI } from "../../utils/service";
import { store } from "../../store";
import * as submittedListActionTypes from "./actionTypes";
import * as submittedListActionCreators from "./actionCreators";
import * as GlobalAction from "../../globalStore/actions";

const submittedWarrantyRoute = endpoints[endpointTypes.SUBMITTEDWARRANTY];

const createRequestObj = (filters) => {
    const state = store.getState();
    const { userInfo, contractorSelection } = state.adminData;
    let address = null;
    if (!!filters.address || !!filters.country || !!filters.zipcode || !!filters.city || !!filters.state) {
        address = {
            country: filters.country || null,
            stateOrProvince: filters.state || null,
            city: filters.city || null,
            zipOrPostal: filters.zipcode || null,
            addressLine1: (filters.address && filters.address.split(",")[0]) || null,
        };
    }
    const reqObj: any = {
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
        warrantyStatusId: filters.warrantyStatus || 0,
        loggedInUser: (userInfo && userInfo.emailAddress) || null,
        isAdminUser: (userInfo && userInfo.isAdmin) || false,
        contractorID: (contractorSelection && contractorSelection.contractorId) || null,
        warranties: filters.warrantyID || null,
        address,
    };
    return reqObj;
};

export function* fetchSubmittedWarrantyList(obj) {
    const payload = createRequestObj(obj.filters);
    const endpoint = submittedWarrantyRoute.endpoints.getSubmittedForms(payload);
    // yield put(GlobalAction.updateLoading(true));
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            yield put(submittedListActionCreators.fetchSubmittedWarrentyListSuccess({ value: response.data }));
        } else {
            yield put(submittedListActionCreators.fetchSubmittedWarrentyListFailure());
        }
        // yield put(GlobalAction.updateLoading(false));
    } catch (err) {
        // Application insight tracking for Exceptions in fetch call
        submittedListActionCreators.fetchSubmittedWarrentyListFailure();
        window["AppInsightTrace"].trackException(`fetchSubmittedWarrantyList failure ${err}`);
        if (err && err.response && err.response.status === 403) {
            yield put(GlobalAction.showAccessDeniedError(err));
        } else {
            yield put(GlobalAction.showGlobalError(err));
        }
        // yield put(GlobalAction.updateLoading(false));
    }
}

export function* getStateProvinceByCountry(obj) {
    const endpoint = submittedWarrantyRoute.endpoints.getStateProvinceList(obj.country);
    // yield put(GlobalAction.updateLoading(true));
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            const stateOrProvinceByCountry = {
                "": [{ label: "Select State", value: "" }],
                USA: [{ label: "Select State", value: "" }],
                CAN: [{ label: "Select Province", value: "" }],
            };
            response.data.forEach((obj) => {
                if (obj.countryId === 1) {
                    stateOrProvinceByCountry["USA"].push({ label: obj.name, value: obj.code });
                } else {
                    stateOrProvinceByCountry["CAN"].push({ label: obj.name, value: obj.code });
                }
            });
            yield put(submittedListActionCreators.fetchStateProviceListSuccess({ value: stateOrProvinceByCountry }));
        } else {
            yield put(submittedListActionCreators.fetchStateProviceListFailure({}));
        }
        // yield put(GlobalAction.updateLoading(false));
    } catch (err) {
        // Application insight tracking for Exceptions in fetch call
        submittedListActionCreators.fetchStateProviceListFailure(err);
        window["AppInsightTrace"].trackException(`fetchStateProvinceList failure ${err}`);
        if (err && err.response && err.response.status === 403) {
            yield put(GlobalAction.showAccessDeniedError(err));
        } else {
            yield put(GlobalAction.showGlobalError(err));
        }
        // yield put(GlobalAction.updateLoading(false));
    }
}

export function* fetchSubmittedList() {
    yield takeEvery(submittedListActionTypes.FETCH_SUBMITTED_WARRANTY_LIST, fetchSubmittedWarrantyList);
    yield takeEvery(submittedListActionTypes.FETCH_STATE_PROVINCE_LIST, getStateProvinceByCountry);
}
